// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditProfileInfo-space1-imIGT {
	margin-bottom: 6px !important;
}

.EditProfileInfo-space2-LgVEw {
	margin-bottom: 12px !important;
}

.EditProfileInfo-space3-cxJ75 {
	margin-bottom: 18px !important;
}

.EditProfileInfo-space4-vOeoc {
	margin-bottom: 24px !important;
}

.EditProfileInfo-space5-Dda4w {
	margin-bottom: 30px !important;
}

.EditProfileInfo-space6-q5gkM {
	margin-bottom: 36px !important;
}

.EditProfileInfo-space7-w6XdN {
	margin-bottom: 42px !important;
}

.EditProfileInfo-space8-u7U71 {
	margin-bottom: 48px !important;
}

.EditProfileInfo-spaceTop1-Q463z {
	margin-top: 6px !important;
}

.EditProfileInfo-spaceTop2-hAZI4 {
	margin-top: 12px !important;
}

.EditProfileInfo-spaceTop3-bKsFM {
	margin-top: 18px !important;
}

.EditProfileInfo-spaceTop4-HHIi8 {
	margin-top: 24px !important;
}

.EditProfileInfo-spaceTop5-Fhk6A {
	margin-top: 30px !important;
}

.EditProfileInfo-spaceTop6-YWHLe {
	margin-top: 36px !important;
}

.EditProfileInfo-spaceTop7-wBR9U {
	margin-top: 42px !important;
}

.EditProfileInfo-spaceTop8-m7Nd2 {
	margin-top: 48px !important;
}

.EditProfileInfo-noMargin-ML2j5 {
	margin: 0px !important;
}

.EditProfileInfo-padding1-ULLiI {
	padding-bottom: 6px !important;
}

.EditProfileInfo-padding2-NgcLw {
	padding-bottom: 12px !important;
}

.EditProfileInfo-padding3-F9wbu {
	padding-bottom: 18px !important;
}

.EditProfileInfo-padding4-t0Rma {
	padding-bottom: 24px !important;
}

.EditProfileInfo-padding5-_Yw80 {
	padding-bottom: 30px !important;
}

.EditProfileInfo-padding6-jaNiS {
	padding-bottom: 36px !important;
}

.EditProfileInfo-padding7-agINT {
	padding-bottom: 42px !important;
}

.EditProfileInfo-paddingTop1-GfYdr {
	padding-top: 6px !important;
}

.EditProfileInfo-paddingTop2-_uzJx {
	padding-top: 12px !important;
}

.EditProfileInfo-paddingTop3-K6nFT {
	padding-top: 18px !important;
}

.EditProfileInfo-paddingTop4-Y0Vi5 {
	padding-top: 24px !important;
}

.EditProfileInfo-paddingTop5-Z5yWf {
	padding-top: 30px !important;
}

.EditProfileInfo-paddingTop6-zHVeB {
	padding-top: 36px !important;
}

.EditProfileInfo-paddingTop7-FZp13 {
	padding-top: 42px !important;
}

.EditProfileInfo-noPadding-mrjbe {
	padding: 0px !important;
}

.EditProfileInfo-spaceMarginBottom0-xriXA {
	margin-bottom: 0;
}

.EditProfileInfo-textBold-o3qOR {
	font-weight: 500 !important;
}

.EditProfileInfo-textBolder-A2xFl {
	font-weight: 700 !important;
}

.EditProfileInfo-textNormal-Vptd2 {
	font-weight: normal !important;
}

/*New Design Text Colors */

.EditProfileInfo-textDarkBlue-xElAu {
	color: rgb(20, 39, 94) !important;
}

.EditProfileInfo-textLightBlue-E0Vs2 {
	color: rgb(57, 87, 106) !important;
}

.EditProfileInfo-textLightSandleGreen-d4AoV {
	color: rgb(76, 86, 41) !important;
}

.EditProfileInfo-textLightBrown-KulBN {
	color: rgb(115, 79, 33) !important;
}

.EditProfileInfo-textMediumMaroon-YiGmt {
	color: rgb(87, 37, 51) !important;
}

.EditProfileInfo-textBrown-f9x07 {
	color: rgb(160, 47, 24) !important;
}

.EditProfileInfo-textMaroon-GRZt_ {
	color: rgb(155, 49, 67) !important;
}

.EditProfileInfo-textDarkBrown-cFiLK {
	color: rgb(83, 18, 16) !important;
}

.EditProfileInfo-textMediumBrown-h7hxt {
	color: rgb(142, 28, 10) !important;
}

.EditProfileInfo-textSkyBlue-Lqxzz {
	color: rgb(37, 117, 141) !important;
}

.EditProfileInfo-textGray-KRt5j {
	color: rgb(77, 65, 51) !important;
}

.EditProfileInfo-errorMessage-oqH6J {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.EditProfileInfo-userText-SODEc {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.EditProfileInfo-panelHeader-S4YSA {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.EditProfileInfo-exportSection-Z_apv {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.EditProfileInfo-exportSectionGridSub-Cbd9S {
	grid-template-columns: 50% 49% !important;
}

.EditProfileInfo-exportText-Uv5bA {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.EditProfileInfo-exportLinkImg-Kxgqd {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.EditProfileInfo-exportImg-W3cew {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.EditProfileInfo-linkBtn-SRaFg {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.EditProfileInfo-table-qlyot {
	display: table;
}

.EditProfileInfo-tableRow-B6H_5 {
	display: table-row;
}

.EditProfileInfo-tableCell-Ur_VT {
	display: table-cell;
	float: none;
}

.EditProfileInfo-formGroup-VDWW8 {
	margin-bottom: 6px;
}

.EditProfileInfo-marginTop0-JcGyK {
	margin-top: 0;
}

.EditProfileInfo-marginBottom20-VGlmF {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.EditProfileInfo-bannerImageBg-uev2N {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.EditProfileInfo-bannerDelete-C26bX {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.EditProfileInfo-exportLink-fUJzk {
	padding-top: 10px;
	padding-right: 10px;
}

.EditProfileInfo-seachContent-gIfno {
	padding-left: 0px;
	margin-bottom: 5px;
}

.EditProfileInfo-marginBottom9-RZ7vx {
	margin-bottom: 9px;
}

.EditProfileInfo-spaceTop52-rSBV9 {
	margin-top: 52px;
}

.EditProfileInfo-profileViewInner-lJMCJ {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.EditProfileInfo-profileViewMain-OuIs8 {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.EditProfileInfo-profileViewlabel-nuskM {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.EditProfileInfo-profileViewMainContent-JTTlL {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.EditProfileInfo-reviewsFormStar-ND2zu {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.EditProfileInfo-reviewsFormStar-ND2zu svg {
	cursor: pointer;
}

.EditProfileInfo-addLanguageText-FRPai {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.EditProfileInfo-exportSection-Z_apv {
		grid-template-columns: 100%;
	}

	.EditProfileInfo-spaceTop52-rSBV9 {
		margin-top: 18px;
	}

	.EditProfileInfo-exportText-Uv5bA {
		float: none;
		margin-top: 12px;
	}

	.EditProfileInfo-exportSectionGridSub-Cbd9S {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.EditProfileInfo-profileViewlabel-nuskM {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.EditProfileInfo-profileViewMainContent-JTTlL {
		width: 100%;
		text-align: center;
	}

	.EditProfileInfo-panelHeader-S4YSA {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.EditProfileInfo-sectionContainer-y47ye {
    margin: 46px auto 0;
    max-width: 950px;
}

.EditProfileInfo-sectionWrapper-D7lZZ {
    border: 1px solid var(--primary-border);
    border-radius: 4px;
    padding: 24px;
}

@media screen and (max-width: 767px) {
    .EditProfileInfo-sectionContainer-y47ye {
        margin-top: 0px;
    }

    .EditProfileInfo-sectionWrapper-D7lZZ {
        padding: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/EditProfile/EditProfileInfo.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACrN3E;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n\n.sectionContainer {\n    margin: 46px auto 0;\n    max-width: 950px;\n}\n\n.sectionWrapper {\n    border: 1px solid var(--primary-border);\n    border-radius: 4px;\n    padding: 24px;\n}\n\n@media screen and (max-width: 767px) {\n    .sectionContainer {\n        margin-top: 0px;\n    }\n\n    .sectionWrapper {\n        padding: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `EditProfileInfo-space1-imIGT`,
	"space2": `EditProfileInfo-space2-LgVEw`,
	"space3": `EditProfileInfo-space3-cxJ75`,
	"space4": `EditProfileInfo-space4-vOeoc`,
	"space5": `EditProfileInfo-space5-Dda4w`,
	"space6": `EditProfileInfo-space6-q5gkM`,
	"space7": `EditProfileInfo-space7-w6XdN`,
	"space8": `EditProfileInfo-space8-u7U71`,
	"spaceTop1": `EditProfileInfo-spaceTop1-Q463z`,
	"spaceTop2": `EditProfileInfo-spaceTop2-hAZI4`,
	"spaceTop3": `EditProfileInfo-spaceTop3-bKsFM`,
	"spaceTop4": `EditProfileInfo-spaceTop4-HHIi8`,
	"spaceTop5": `EditProfileInfo-spaceTop5-Fhk6A`,
	"spaceTop6": `EditProfileInfo-spaceTop6-YWHLe`,
	"spaceTop7": `EditProfileInfo-spaceTop7-wBR9U`,
	"spaceTop8": `EditProfileInfo-spaceTop8-m7Nd2`,
	"noMargin": `EditProfileInfo-noMargin-ML2j5`,
	"padding1": `EditProfileInfo-padding1-ULLiI`,
	"padding2": `EditProfileInfo-padding2-NgcLw`,
	"padding3": `EditProfileInfo-padding3-F9wbu`,
	"padding4": `EditProfileInfo-padding4-t0Rma`,
	"padding5": `EditProfileInfo-padding5-_Yw80`,
	"padding6": `EditProfileInfo-padding6-jaNiS`,
	"padding7": `EditProfileInfo-padding7-agINT`,
	"paddingTop1": `EditProfileInfo-paddingTop1-GfYdr`,
	"paddingTop2": `EditProfileInfo-paddingTop2-_uzJx`,
	"paddingTop3": `EditProfileInfo-paddingTop3-K6nFT`,
	"paddingTop4": `EditProfileInfo-paddingTop4-Y0Vi5`,
	"paddingTop5": `EditProfileInfo-paddingTop5-Z5yWf`,
	"paddingTop6": `EditProfileInfo-paddingTop6-zHVeB`,
	"paddingTop7": `EditProfileInfo-paddingTop7-FZp13`,
	"noPadding": `EditProfileInfo-noPadding-mrjbe`,
	"spaceMarginBottom0": `EditProfileInfo-spaceMarginBottom0-xriXA`,
	"textBold": `EditProfileInfo-textBold-o3qOR`,
	"textBolder": `EditProfileInfo-textBolder-A2xFl`,
	"textNormal": `EditProfileInfo-textNormal-Vptd2`,
	"textDarkBlue": `EditProfileInfo-textDarkBlue-xElAu`,
	"textLightBlue": `EditProfileInfo-textLightBlue-E0Vs2`,
	"textLightSandleGreen": `EditProfileInfo-textLightSandleGreen-d4AoV`,
	"textLightBrown": `EditProfileInfo-textLightBrown-KulBN`,
	"textMediumMaroon": `EditProfileInfo-textMediumMaroon-YiGmt`,
	"textBrown": `EditProfileInfo-textBrown-f9x07`,
	"textMaroon": `EditProfileInfo-textMaroon-GRZt_`,
	"textDarkBrown": `EditProfileInfo-textDarkBrown-cFiLK`,
	"textMediumBrown": `EditProfileInfo-textMediumBrown-h7hxt`,
	"textSkyBlue": `EditProfileInfo-textSkyBlue-Lqxzz`,
	"textGray": `EditProfileInfo-textGray-KRt5j`,
	"errorMessage": `EditProfileInfo-errorMessage-oqH6J`,
	"userText": `EditProfileInfo-userText-SODEc`,
	"panelHeader": `EditProfileInfo-panelHeader-S4YSA`,
	"exportSection": `EditProfileInfo-exportSection-Z_apv`,
	"exportSectionGridSub": `EditProfileInfo-exportSectionGridSub-Cbd9S`,
	"exportText": `EditProfileInfo-exportText-Uv5bA`,
	"exportLinkImg": `EditProfileInfo-exportLinkImg-Kxgqd`,
	"exportImg": `EditProfileInfo-exportImg-W3cew`,
	"linkBtn": `EditProfileInfo-linkBtn-SRaFg`,
	"table": `EditProfileInfo-table-qlyot`,
	"tableRow": `EditProfileInfo-tableRow-B6H_5`,
	"tableCell": `EditProfileInfo-tableCell-Ur_VT`,
	"formGroup": `EditProfileInfo-formGroup-VDWW8`,
	"marginTop0": `EditProfileInfo-marginTop0-JcGyK`,
	"marginBottom20": `EditProfileInfo-marginBottom20-VGlmF`,
	"bannerImageBg": `EditProfileInfo-bannerImageBg-uev2N`,
	"bannerDelete": `EditProfileInfo-bannerDelete-C26bX`,
	"exportLink": `EditProfileInfo-exportLink-fUJzk`,
	"seachContent": `EditProfileInfo-seachContent-gIfno`,
	"marginBottom9": `EditProfileInfo-marginBottom9-RZ7vx`,
	"spaceTop52": `EditProfileInfo-spaceTop52-rSBV9`,
	"profileViewInner": `EditProfileInfo-profileViewInner-lJMCJ`,
	"profileViewMain": `EditProfileInfo-profileViewMain-OuIs8`,
	"profileViewlabel": `EditProfileInfo-profileViewlabel-nuskM`,
	"profileViewMainContent": `EditProfileInfo-profileViewMainContent-JTTlL`,
	"reviewsFormStar": `EditProfileInfo-reviewsFormStar-ND2zu`,
	"addLanguageText": `EditProfileInfo-addLanguageText-FRPai`,
	"sectionContainer": `EditProfileInfo-sectionContainer-y47ye`,
	"sectionWrapper": `EditProfileInfo-sectionWrapper-D7lZZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
